// Shared constants for the domain setup wizard.

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const INDUSTRIES = [
  // ── Domain-level industry categories ────────────────────────────
  { value: 'car_dealership',      label: 'Car Dealership' },
  { value: 'real_estate',         label: 'Real Estate' },
  { value: 'legal_firm',          label: 'Legal Firm' },
  { value: 'it_support',          label: 'IT Support / MSP' },
  { value: 'it_technical',        label: 'IT Technical Support' },
  { value: 'customer_support',    label: 'Customer Support' },
  { value: 'customer_service',    label: 'Customer Service' },
  { value: 'service_department',  label: 'Service Department' },
  { value: 'service_management',  label: 'Service Management' },
  { value: 'dental_clinic',       label: 'Dental Clinic' },
  { value: 'finance_mortgage',    label: 'Finance & Mortgage' },
  { value: 'insurance_broker',    label: 'Insurance Broker' },
  { value: 'construction',        label: 'Construction' },
  { value: 'education_training',  label: 'Education & Training' },
  { value: 'recruitment',         label: 'Recruitment' },
  { value: 'property_management', label: 'Property Management' },
  { value: 'b2b_sales',           label: 'B2B Sales' },
  { value: 'fitness_gym',         label: 'Fitness & Gyms' },
  { value: 'emergency_services',  label: 'Emergency Services' },
  // ── Coaching categories (per-extension) ──────────────────────────
  { value: 'manager_leadership',  label: 'Management — Leadership' },
  { value: 'manager_other',       label: 'Management — Other' },
  { value: 'manager_general',     label: 'Management — General' },
  { value: 'admin_accounts',      label: 'Admin — Accounts' },
  { value: 'admin_general',       label: 'Admin — General (Legacy)' },
  { value: 'admin_other',         label: 'Admin — Other' },
  { value: 'admin',               label: 'Administration' },
  { value: 'sales_new',           label: 'Sales — New Business' },
  { value: 'sales_bdm',           label: 'Sales — BDM' },
  { value: 'sales_used',          label: 'Sales — Pre-owned' },
  { value: 'sales_parts',         label: 'Parts & Accessories' },
  { value: 'practitioner',        label: 'Practitioner' },
  { value: 'general',             label: 'General (Catch-all)' },
  { value: 'other',               label: 'Other' },
];

export const industryLabel = (val) => INDUSTRIES.find(i => i.value === val)?.label || val;

export const STEPS = ['Company Details', 'Domain & Industry', 'Extensions', 'Notifications & Confirm'];
